import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  InputGroup,
  InputGroupText,
  Label,
  Spinner,
  Card,
  CardBody,
  NavLink,
} from "reactstrap"; 
// import axios from "axios";
import Select from "react-select";
import { Tabs, Tab } from "@tarragon/swipeable-tabs";
// import { Row, Tab, Tabs } from "react-bootstrap";
import AppliedJobs from "./AppliedJobs";
import SavedJobs from "./SavedJobs";
import JobOffers from "./JobOffers";
import CallingForInterviews from "./CallingForInterviews";
import Header from "../../Navigation/Header";
import { Helmet } from "react-helmet";
//import axios from "axios";
import axios from "../../../API/axios";
import OfferAJobs from "../../ManageJob/OfferAJobs";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import { selectThemeColors } from '@utils'
// import '@styles/react/libs/react-select/_react-select.scss'

const MANAGE_JOBS_TAB_MAP = {
  applied: 1,
  offeredjobs: 2,
  savedjobs: 3,
  interviewscheduled: 4,
};

const MANAGE_JOBS_TAB_ROUTES = {
  1: "Applied",
  2: "OfferedJobs",
  3: "SavedJobs",
  4: "InterviewScheduled",
};

const getManageJobsTabIndex = (routeTab) => {
  const tabKey = (routeTab || "").toLowerCase();
  return MANAGE_JOBS_TAB_MAP[tabKey] || 1;
};

const History = () => {
  const sessionId = localStorage.getItem("sessionId");
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState("Tab 1");
  const [tabsCount, setTabsCount] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const { tab } = useParams();
  const [activeTab, setActiveTab] = useState(() => getManageJobsTabIndex(tab));

  const goToManageJobsTab = (tabIndex) => {
    setActiveTab(tabIndex);
    const tabPath = MANAGE_JOBS_TAB_ROUTES[tabIndex];
    if (tabPath) {
      navigate(`/ManageJobs/${tabPath}`);
    }
  };

  const changeTab = (event) => {
    setSelectedTab(event.label);
  };

  const getCountofAllTabs = () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
    };
    axios
      .post(`ManageJob/GetManageJobStats`, data)
      .then((response) => {
        // console.log("GetManageJObsStatus===>", response.data);
        const res = response?.data?.responseData;
        setTabsCount(res);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  useEffect(() => {
    getCountofAllTabs();
  }, [sessionId]);

  const renderTabContent = () => {

    switch (activeTab) {
      case 1:
        return (
          <>
            {/* <AppliedJobs /> */}
            <AppliedJobs
              tabsCount={tabsCount}
              setTabsCount={setTabsCount}
            />
          </>
        );
      case 2:
        return (
          <>
            <JobOffers />
          </>
        );
      case 3:
        return (
          <>
            <SavedJobs
              tabsCount={tabsCount}
              setTabsCount={setTabsCount}
            />
          </>
        );
      case 4:
        return (

          <>
            <CallingForInterviews />
          </>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    setActiveTab(getManageJobsTabIndex(tab));
  }, [tab]);


  // change page scroll top
  //  useEffect(() => {
  //     const scrollToTop = () => {
  //       window.scrollTo({ top: 0, behavior: "smooth" });
  //     };
  //     scrollToTop();
  //   }, []);


  useEffect(() => {
    if (location.pathname.startsWith("/ManageJobs")) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.pathname]);


  return (
    <>
      <Helmet>
        <title>Manage Jobs | Welinkjobs </title>
        <meta name="description" content="Easy manage jobs with Welinkjobs. Experience efficiency on one of the most trusted job search sites." />
        {/* <meta name="keywords" content="react, meta tags, seo" /> */}
        {/* <meta name="author" content="Your Name" /> */}
        <meta property="og:title" content="Welinkjobs: Effortlessly Manage Jobs Online" />
        <meta property="og:description" content="Easy manage jobs with Welinkjobs. Experience efficiency on one of the most trusted job search sites." />
        {/* <meta property="og:image" content="https://example.com/image.jpg" /> */}
        <meta property="og:url" content="https://welinkjobs.com/ManageJobs" />
      </Helmet>
      {/* <div className="jobSearch-main-container">

        <div className="job-history row deskT my-3 mt-5">

          <div className="row p-0">
            <div className="col-md-6 col-lg-4">
              <AppliedJobs />
            </div>

            <div className="col-md-6 col-lg-4">
              <SavedJobs />
            </div>

            {/* <div className="col-md-6 col-lg-4">
              <JobOffers />
            </div> 

            <div className="col-md-6 col-lg-4">
              <CallingForInterviews />
            </div>
          </div>
        </div>

        <div className="job-history row mobT mt-5 connectionPage">
          <div className="tabButton d-flex p-3 w-100 mt-4 ps-0 connectionTab">
            {/* {loading && <Loading />} 
            <NavLink
              onClick={() => setActiveTab(1)}
              className={`text-center ${activeTab === 1 ? "activeTab" : ""}`}
            >
              <p className="f-14 tabName">Applied Jobs</p>
            </NavLink>
            <NavLink
              onClick={() => setActiveTab(2)}
              className={`text-center ${activeTab === 2 ? "activeTab" : ""}`}
            >
              <p className="f-14 tabName">Saved Jobs</p>
            </NavLink>
            <NavLink
              onClick={() => setActiveTab(3)}
              className={`text-center ${activeTab === 3 ? "activeTab" : ""}`}
            >
              <p className="f-14 tabName">Job Offers</p>
            </NavLink>
            <NavLink
              onClick={() => setActiveTab(4)}
              className={`text-center ${activeTab === 4 ? "activeTab" : ""}`}
            >
              <p className="f-14 tabName">Calling for Interviews</p>
            </NavLink>
          </div> 
          {/* <Tabs value={selectedTab} onChange={changeTab}>
            <Tab label="Applied Jobs" key={0} className="col-md-6 col-lg-3">
              <AppliedJobs />
            </Tab>
            <Tab label="Saved Jobs" key={1} className="col-md-6 col-lg-3">
              <SavedJobs />
            </Tab>
            <Tab label="Job Offers" key={2} className="col-md-6 col-lg-3">
              <JobOffers />
            </Tab>
            <Tab
              label="Calling for Interviews"
              key={3}
              className="col-md-6 col-lg-3"
            >
              <CallingForInterviews />
            </Tab>
          </Tabs> 
          {renderTabContent()}
        </div>
      </div>*/}
      <div>
        <div className="friendsHeaderText p-2 pt-0 pb-0 mt-4 ">
          <h1>{t("Manage Job.Manage Jobs")}</h1>
        </div>
        <div className="job-history deskT">

          {/* Tab Buttons */}
          <div className="tabButton d-flex p-2 w-100 me-2 connectionTab">
            <NavLink
              // onClick={() => setActiveTab(1)}
              onClick={() => goToManageJobsTab(1)}
              className={`text-center ${activeTab === 1 ? "activeTab" : ""}`}
            >
              <p className="f-14 tabName">{t("Manage Job.Applied Jobs")}{tabsCount?.totalJobApplications != null ? ` (${tabsCount?.totalJobApplications})` : ''}</p>
              {/* <p className="f-14 tabCount">{tabsCount?.totalJobApplications}</p> */}
            </NavLink>

            <NavLink
              // onClick={() => setActiveTab(2)}
              onClick={() => goToManageJobsTab(2)}
              className={`text-center ${activeTab === 2 ? "activeTab" : ""}`}
            >
              <p className="f-14 tabName">{t("Manage Job.Jobs Offered")}{tabsCount?.totalJobOffers != null ? ` (${tabsCount?.totalJobOffers})` : ''}</p>
              {/* <p className="f-14 tabCount">{tabsCount?.totalJobOffers}</p> */}
            </NavLink>

            <NavLink
              // onClick={() => setActiveTab(4)}
              onClick={() => goToManageJobsTab(3)}
              className={`text-center ${activeTab === 3 ? "activeTab" : ""}`}
            >
              <p className="f-14 tabName">{t("Manage Job.Saved Jobs")}{tabsCount?.totalSavedJobs != null ? ` (${tabsCount?.totalSavedJobs})` : ''}</p>
              {/* <p className="f-14 tabCount">{tabsCount?.totalSavedJobs}</p> */}
            </NavLink>

            <NavLink
              // onClick={() => setActiveTab(3)}
              onClick={() => goToManageJobsTab(4)}
              className={`text-center ${activeTab === 4 ? "activeTab" : ""}`}
            >
              <p className="f-14 tabName">{t("Manage Job.Interview Scheduled")}{tabsCount?.totalScheduledInterviews != null ? ` (${tabsCount?.totalScheduledInterviews})` : ''}</p>
              {/* <p className="f-14 tabCount">{tabsCount?.totalScheduledInterviews}</p> */}
            </NavLink>
          </div>

          {/* Tab Content */}
          <div className="tab-content">
            {activeTab === "Applied" && (
              <div className="tab-pane active pointer">
                <AppliedJobs />
              </div>
            )}
            {activeTab === "OfferedJobs" && (
              <div className="tab-pane active pointer">
                <OfferAJobs />
              </div>
            )}
            {activeTab === "SavedJobs" && (
              <div className="tab-pane active pointer">
                <SavedJobs />
              </div>
            )}
            {activeTab === "InterviewsScheduled" && (
              <div className="tab-pane active pointer">
                <CallingForInterviews />
              </div>
            )}
          </div>
        </div>
      </div>
      {renderTabContent()}
    </>
  );
};

export default History;
